export function randString(length) {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}

export function removeLastWord(text){
    let newText = text.split(" ");
    newText[newText.length - 1] = "";
    newText = newText.join(" ");
    return newText;
}

export function getLastWord(text){
    let array = text.split(" ");
    return array[array.length - 1];
}